/** Keys / patterns whose values must never leave the browser. */
const SENSITIVE_KEY = /^(authorization|token|accessToken|refreshToken|password|passwd|secret|apiKey|api_key|email|record|payload|records)$/i;
const BEARER_RE = /Bearer\s+[A-Za-z0-9\-._~+/]+=*/gi;
const JWT_RE = /eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]*/g;
const EMAIL_RE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;

/**
 * Scrub tokens, Authorization headers, record payloads, and emails from
 * arbitrary error / context trees before they are reported.
 */
export function scrubValue(value: unknown, key?: string): unknown {
  if (key && SENSITIVE_KEY.test(key)) {
    return '[REDACTED]';
  }
  if (value == null) {
    return value;
  }
  if (typeof value === 'string') {
    return scrubString(value);
  }
  if (typeof value !== 'object') {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map((item) => scrubValue(item));
  }
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
    out[k] = scrubValue(v, k);
  }
  return out;
}

export function scrubString(input: string): string {
  return input
    .replace(BEARER_RE, 'Bearer [REDACTED]')
    .replace(JWT_RE, '[REDACTED_JWT]')
    .replace(EMAIL_RE, '[REDACTED_EMAIL]');
}

export function scrubError(error: unknown): Record<string, unknown> {
  if (error == null) {
    return {message: 'Unknown error'};
  }
  if (typeof error === 'string') {
    return {message: scrubString(error)};
  }
  if (error instanceof Error) {
    return scrubValue({
      name: error.name,
      message: error.message,
      stack: error.stack,
    }) as Record<string, unknown>;
  }
  return scrubValue(error) as Record<string, unknown>;
}
